import { Directive, TemplateRef } from '@angular/core';

// tslint:disable: max-classes-per-file
@Directive({
    selector: '[emma-table-actions-right-tmp]',
    standalone: false
})
export class EMMATableActionsRightTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[emma-table-actions-left-tmp]',
    standalone: false
})
export class EMMATableActionsLeftTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[emma-table-no-results-tmp]',
    standalone: false
})
export class EMMATableNoResultsTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[emma-table-header-tmp]',
    standalone: false
})
export class EMMATableHeaderTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[emma-table-footer-tmp]',
    standalone: false
})
export class EMMATableFooterTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
